import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getAllTeams = () => {
  return useApi(http.get('/teams'))
}

export const getTeamMembers = (id: any) => {
  return useApi(http.get(`/teams/${id}/members`))
}

export const deleteTeams = (id: string) => {
  return useApi(http.delete(`/teams/${id}`))
}

export const createTeams = (data: any) => {
  return useApi(http.post('/teams', data))
}

export const updateTeams = (id: string, data: any) => {
  return useApi(http.patch(`/teams/${id}`, data))
}

export const getTeams = (id: number) => {
  return useApi(http.get(`/teams/${id}`))
}
